import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { Table, Image, InputNumber, Tag } from "antd";
import { showConfirmDlgWidget } from "components/ConfirmDlgWidget/showConfirmDlgWidget";
import dragula from "dragula";
import "dragula/dist/dragula.css";
import { useEffect } from "react";
import { apiUpdateVideoPosition } from "services/videoListService";
import { DragOutlined, PlayCircleOutlined } from "@ant-design/icons";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const getIndexInParent = (el) => Array.from(el.parentNode.children).indexOf(el);

function TableWidget(props) {
  const [isBusy, setIsBusy] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const {
    dataList,
    setDataList,
    onUpdateAction,
    onDeleteAction,
    onDetailAction,
  } = props;

  useEffect(() => {
    let start;
    let end;
    const container = document.querySelector(".ant-table-tbody");
    const drake = dragula([container], {
      moves: (el) => {
        start = getIndexInParent(el);
        return true;
      },
    });

    drake.on("drop", (el) => {
      end = getIndexInParent(el);
      handleReorder(start, end);
    });
  }, []);

  useEffect(() => {
    if (dataList !== undefined) {
      setDataSource([
        ...dataList.map((info) => {
          return { ...info, key: info.id, icon: <DragOutlined type="swap" /> };
        }),
      ]);
    }
  }, [dataList]);
  if (dataList === undefined) return <div />;

  const columns = [
    {
      title: <DragOutlined type="swap" />,
      dataIndex: "icon",
    },
    {
      title: "ID",
      dataIndex: "id",
    },
    {
      title: "Video",
      dataIndex: "url",
      render: (text, record) => {
        if (record.url) {
          return (
            <video
              src={record.url}
              width={200}
              height={120}
              controls
              preload="metadata"
              muted
              style={{ borderRadius: 8 }}
            />
          );
        }

        return (
          <div
            style={{
              width: 200,
              height: 120,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#f5f5f5",
              borderRadius: 8,
            }}
          >
            <PlayCircleOutlined style={{ fontSize: 40 }} />
          </div>
        );
      },
    },
    {
      title: "Name",
      dataIndex: "name",
      align: "center",
      sorter: {
        compare: (a, b) => {
          // Strip HTML tags for comparison
          const stripHtml = (html) => {
            const tmp = document.createElement("DIV");
            tmp.innerHTML = html || "";
            return tmp.textContent || tmp.innerText || "";
          };
          return stripHtml(a.name).localeCompare(stripHtml(b.name));
        },
      },
      render: (text, record) => {
        return (
          <div 
            style={{ 
              maxWidth: 300, 
              textAlign: "left",
            }}
            className="table-quill-display"
          >
            <ReactQuill
              value={record.name || ""}
              readOnly={true}
              theme="snow"
              modules={{ toolbar: false }}
            />
          </div>
        );
      },
    },
    {
      title: "Publish",
      dataIndex: "status",
      align: "center",
      sorter: {
        compare: (a, b) => a.status.localeCompare(b.status),
      },
      render: (text, record) => {
        return (
          <Tag
            color={
              record.status === "1" ? "var(--blueColor)" : "var(--orangeColor)"
            }
          >
            {record.status === "1" ? "Yes" : "No"}
          </Tag>
        );
      },
    },
    {
      title: "Updated At",
      dataIndex: "update_timestamp",
      align: "center",
      sorter: {
        compare: (a, b) => a.update_timestamp.localeCompare(b.update_timestamp),
      },
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (text, record) => {
        return (
          <div size="middle" direction={"vertical"}>
            <a
              style={{ color: "var(--orangeColor)", marginLeft: 20 }}
              className="edit-btn"
              onClick={() => {
                onUpdateAction(record);
              }}
            >
              Edit
            </a>
            <a
              style={{ color: "var(--redColor)", marginLeft: 20 }}
              className="del-btn"
              onClick={async () => {
                var res = await showConfirmDlgWidget({
                  title: "Delete Confirmation",
                  content: "Are you sure to delete this record?",
                });
                if (res == false) return;
                onDeleteAction(record);
              }}
            >
              Delete
            </a>
          </div>
        );
      },
    },
  ];

  const handleReorder = (dragIndex, draggedIndex) => {
    setDataSource((oldState) => {
      const newState = [...oldState];
      const item = newState.splice(dragIndex, 1)[0];
      newState.splice(draggedIndex, 0, item);
      apiUpdateVideoPosition(newState);
      return newState;
    });
  };

  return (
    <>
      <style>
        {`
          .table-quill-display .ql-container {
            border: none !important;
            font-size: 14px;
          }
          .table-quill-display .ql-editor {
            padding: 0 !important;
          }
          .table-quill-display .ql-editor.ql-blank::before {
            display: none;
          }
        `}
      </style>
      <div className="list-table">
        <Table pagination={false} columns={columns} dataSource={dataSource} />
      </div>
    </>
  );
}

export default withRouter(TableWidget);
